import React, {useState} from "react";
import {useParams, Link, useNavigate} from "react-router-dom";
import {Card, Container, Alert, Form, Button, InputGroup} from "react-bootstrap";
import * as yup from "yup";
import {Formik} from "formik";
import bctcLogo from "../../images/BCTC_Logo_Horiz_small.png";
import {authApi} from "../../api/auth.js";

const schema = yup.object().shape({
  password: yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "Must be at least 8 chars with upper, lower, number"
    ),
  confirmPassword: yup.string()
    .required("Confirm password is required")
    .oneOf([yup.ref("password")], "Passwords must match")
});

function AcceptInvitePage() {
    const {activationKey} = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState({success: false, error: ""});
    
    return (
        <div className="auth-layout">
            <Container style={{maxWidth: 640}}>
                <Card className="auth-card p-4 mx-auto">
                    <div className="auth-header">
                        <img src={bctcLogo} height="64" alt="BCTC logo" />
                        <h1 style={{fontFamily: "Bitter, Georgia, serif"}}>Set your password</h1>
                        <p className="text-muted mb-0">Finish your invite to access the portal.</p>
                    </div>
                    {state.error && <Alert variant="danger">{state.error}</Alert>}
                    {state.success ? (
                        <Alert variant="success">
                            Your account is activated. <Link to="/login">Sign in</Link>
                        </Alert>
                    ) : (
                        <Formik
                            validationSchema={schema}
                            onSubmit={async (values, {setSubmitting}) => {
                                setState({success: false, error: ""});
                                try {
                                    await authApi.acceptInvite(activationKey, values.password);
                                    setState({success: true, error: ""});
                                } catch (err) {
                                    console.error(err);
                                    setState({success: false, error: "Unable to accept invite. The link may be invalid or expired."});
                                } finally {
                                    setSubmitting(false);
                                }
                            }}
                            initialValues={{
                                password: "",
                                confirmPassword: ""
                            }}
                        >
                            {({handleSubmit, handleChange, values, touched, errors, isSubmitting}) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>New Password</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><i className="bi bi-lock"></i></InputGroup.Text>
                                            <Form.Control
                                                type="password"
                                                name="password"
                                                placeholder="Password"
                                                value={values.password}
                                                onChange={handleChange}
                                                isInvalid={touched.password && !!errors.password}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.password}ddd
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Confirm Password</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><i className="bi bi-lock-fill"></i></InputGroup.Text>
                                            <Form.Control
                                                type="password"
                                                name="confirmPassword"
                                                placeholder="Confirm password"
                                                value={values.confirmPassword}
                                                onChange={handleChange}
                                                isInvalid={touched.confirmPassword && !!errors.confirmPassword && console.log(errors)}
                                            />
                                        </InputGroup>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.confirmPassword}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <div className="d-grid mb-2">
                                        <Button type="submit" disabled={isSubmitting}>Set Password</Button>
                                    </div>
                                    <div className="text-center">
                                        <Link to="/login" className="text-primary">Back to login</Link>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    )}
                </Card>
            </Container>
        </div>
    );
}

export default AcceptInvitePage;
